import React from "react";
import { Balancer } from "react-wrap-balancer";
import { AccordionButton as ChakraAccordionButton, Flex, Text } from "@chakra-ui/react";
import { ChevronDownIcon } from "ui/icons";
import { ProgressBar } from "./progress-bar";

export type AccordionButtonProps = {
  eyebrow?: string;
  label: string;
  isExpanded: boolean;
  isInView: boolean;
  animationDuration: number;
};

export function AccordionButton(props: AccordionButtonProps) {
  const { eyebrow, label, isExpanded, isInView } = props;

  return (
    // Add aria-label to h3 for cleaner SEO
    <Text as="h3" aria-label={`${eyebrow ? eyebrow + ": " + label : label}`} textStyle="h6">
      <ChakraAccordionButton
        aria-label={label}
        pos="relative"
        color="text.secondary"
        textStyle="inherit"
        fontSize="inherit"
        fontWeight="inherit"
        flexDir="column"
        alignItems="start"
        p={0}
        _expanded={{ color: "text.primary" }}
        _hover={{ bg: "transparent", color: "text.primary" }}
      >
        {isExpanded && isInView && <ProgressBar {...props} />}

        {eyebrow && (
          <Text mb={3} fontSize={{ base: "sm", lg: "md" }} textStyle="uppercase">
            {eyebrow}
          </Text>
        )}

        <Flex gap={3} align="center" justify="space-between" w="100%">
          <Text textAlign="left">
            <Balancer>{label}</Balancer>
          </Text>

          <ChevronDownIcon
            boxSize={10}
            transform={isExpanded ? "rotate(180deg)" : "none"}
            transition="transform 300ms ease"
          />
        </Flex>
      </ChakraAccordionButton>
    </Text>
  );
}
